import { Nullable } from '../types/custom/Nullable';
import { fetchBrary } from './FetchBrary';

class ApiRequest {

    // The environment url
    private static readonly EnvironmentUrl: string | undefined = process.env.REACT_APP_API_URL;
    // the default path url
    private static readonly RootUrl: string = 'api';
    private static readonly GlobalUrlPrefix: string = `${ApiRequest.EnvironmentUrl}/${ApiRequest.RootUrl}`;

    private static generateUrl(url: string): string {
        return `${ApiRequest.GlobalUrlPrefix}/${url}`;
    }

    /**
     * Performs an HTTP GET, coercing the response into the generic type specified.
     * @param url The url of the route. Do not include /api/
     */
    public async get<T>(url: string): Promise<T> {
        const result = await fetchBrary.get(ApiRequest.generateUrl(url));
        return result as T;
    }

        /**
     * Makes an internal API request to the supplied url, and returns the contents as a file blob.
     * @param url The url of the route. Do not include /api/
     * @param queryParams Any query string parameters to include. Name / Value pairs will be appended to the request url in query string format. 
     */
    public async downloadBlob(url: string, queryParams?: Nullable<unknown>): Promise<Blob> {
        const result = await fetchBrary._getAsHttpResponse(ApiRequest.generateUrl(url), queryParams);
        const blob = await result.blob();
        return blob;
    }

/**
     * Performs an HTTP POST, with no response object desired.
     * @param url The url of the route. Do not include /api/
     * @param data The data to post.
     */
    public async post(url: string, data?: any): Promise<void>;

    /**
     * Performs an HTTP POST, casted as the type specified.
     * @param url The url of the route. Do not include /api/
     * @param data The data to post.
     */
    public async post<T>(url: string, data?: any): Promise<T>;

    /**
     * Performs an HTTP POST, casted as the type specified.
     * @param url The url of the route. Do not include /api/
     * @param data The data to post.
     */
    public async post<T>(url: string, data?: any) {
        const apiResult = await fetchBrary.dynamicPost(ApiRequest.generateUrl(url), data);
        return apiResult as T;
    }

        /**
     * Performs an HTTP PUT, with no response object desired.
     * @param url The url of the route. Do not include /api/
     * @param data The data to place in the request body.
     */
    public async put(url: string, data?: any): Promise<void> {
        // This fetchbrary method actually returns something, but I don't think it's useful.
        await fetchBrary.put(ApiRequest.generateUrl(url), data);
    }

        /**
     * Performs an HTTP DELETE, with no response object desired.
     * @param url The url of the route. Do not include /api/
     * @param data The data to place in the request body.
     */
    public async delete(url: string) : Promise<void> {
        await fetchBrary.delete(ApiRequest.generateUrl(url));
    }
}

const StaticApiRequest = new ApiRequest();
export default StaticApiRequest;